<template>
  <div class="store-info-cell c:row-between-center">
    <div class="store-info-label">{{ label }}</div>
    <div class="store-info-value"><slot /></div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
  },
};
</script>

<style lang="less" scoped>
.store-info-cell {
  gap: 6/20rem;

  box-sizing: border-box;
  width: 100%;
  height: 48/20rem;
  border-top: solid 1px #f1f1f1;

  line-height: 20/20rem;
  font-weight: 500;
  font-size: 14/20rem;
  letter-spacing: 0;
}

.store-info-label {
  color: #333;
}

.store-info-value {
  color: #b3b3b3;
}
</style>
